module.exports = __webpack_public_path__ + "product/startkit-image-d34a27e118a27204d7b8b03280ecad9e.png";